// Shared input class string. Kept in its own module (rather than exported from
// FormField.tsx) so component files only export components — which keeps Vite
// fast-refresh working. Imported by the field primitives and every screen that
// renders a raw <input>.
export const inputClassName = [
  'w-full',
  'h-12',
  'px-3',
  'rounded-[var(--radius-md)]',
  '[border-width:var(--border-field-width)]',
  'border-[color:var(--color-field-border)]',
  'bg-[color:var(--color-surface-container-lowest)]',
  'text-[color:var(--color-text-primary)]',
  'font-[family-name:var(--font-body)]',
  'text-[length:var(--text-body-sm)]',
  'outline-none',
  'appearance-none',
  'transition-[border-color,box-shadow]',
  'duration-[var(--duration-standard)]',
  'placeholder:text-[color:var(--color-text-tertiary)]',
  'focus:border-[color:var(--color-outline-focus)]',
  'focus:shadow-[var(--shadow-focus-ring)]',
  'aria-[invalid=true]:border-[color:var(--color-error-border)]',
  // Locked-until-processed state (MAF 29-05): fields backed by a mandatory
  // document can't be typed into until DocAI returns. Greyed background, muted
  // text/placeholder and a softened border make the field read as clearly
  // inactive (rather than just faded).
  'disabled:cursor-not-allowed',
  'disabled:bg-[color:var(--color-field-background-disabled)]',
  'disabled:text-[color:var(--color-field-text-disabled)]',
  'disabled:placeholder:text-[color:var(--color-field-text-disabled)]',
  'disabled:border-[color:var(--color-field-border-disabled)]',
  'disabled:shadow-none',
].join(' ')
